import React, { useState } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './styles/App.css';
import Contact from './components/contact';
import Home from './pages/Home';
import NavBar from './components/NavBar';
import About from './pages/About';
import Gallery from './pages/Gallery';
import GlobePage from './pages/3DGlobe';
import ArtMapDemo from './pages/ArtMapDemo';
import Francemap from './pages/francemap';
import Services from './pages/Services';
import { sendInvoiceRequest } from './utils/invoiceRequest';
const Portfolio = React.lazy(() => import('./pages/Portfolio'));

const initialRequestData = {
  name: '',
  email: '',
  phone: '',
  type: 'GIS Consulting',
  company: '',
  moreInformation: '',
};

function App() {
  const [isRequestPopupOpen, setIsRequestPopupOpen] = useState(false);
  const [requestSubmitted, setRequestSubmitted] = useState(false);
  const [requestSubmitting, setRequestSubmitting] = useState(false);
  const [requestError, setRequestError] = useState('');
  const [requestData, setRequestData] = useState(initialRequestData);

  const openRequestPopup = () => {
    setRequestSubmitted(false);
    setRequestError('');
    setIsRequestPopupOpen(true);
  };

  const closeRequestPopup = () => {
    setIsRequestPopupOpen(false);
  };

  const handleRequestChange = (event) => {
    const { name, value } = event.target;
    setRequestSubmitted(false);
    setRequestError('');
    setRequestData((previous) => ({ ...previous, [name]: value }));
  };

  const handleRequestSubmit = async (event) => {
    event.preventDefault();
    setRequestSubmitting(true);
    setRequestError('');
    try {
      await sendInvoiceRequest(requestData, 'Navbar Popup');
      setRequestSubmitted(true);
      setRequestData(initialRequestData);
    } catch (error) {
      setRequestSubmitted(false);
      setRequestError('Unable to send right now. Please try again in a moment.');
    } finally {
      setRequestSubmitting(false);
    }
  };

  return (
    <Router>
      <div className="App">
        <NavBar onContactClick={openRequestPopup} />
        <main>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/portfolio" element={<React.Suspense fallback={<div>Loading...</div>}><Portfolio /></React.Suspense>} />
            <Route path="/about" element={<About />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/gallery" element={<Gallery />} />
            <Route path="/francemap" element={<Francemap />} />
            <Route path="/globe" element={<GlobePage />} />
            <Route path="/artmap" element={<ArtMapDemo />} />
            <Route path="/services" element={<Services />} />
          </Routes>
        </main>

        {isRequestPopupOpen && (
          <div className="global-request-backdrop" onClick={closeRequestPopup}>
            <div
              className="global-request-modal"
              role="dialog"
              aria-modal="true"
              aria-labelledby="global-request-title"
              onClick={(event) => event.stopPropagation()}
            >
              <button
                type="button"
                className="global-request-close"
                onClick={closeRequestPopup}
                aria-label="Close request form"
              >
                x
              </button>
              <h3 id="global-request-title">Invoice Request</h3>

              <form className="global-request-form" onSubmit={handleRequestSubmit}>
                <label htmlFor="global-name">Name</label>
                <input
                  id="global-name"
                  name="name"
                  type="text"
                  value={requestData.name}
                  onChange={handleRequestChange}
                  required
                />

                <label htmlFor="global-email">Email</label>
                <input
                  id="global-email"
                  name="email"
                  type="email"
                  value={requestData.email}
                  onChange={handleRequestChange}
                  required
                />

                <label htmlFor="global-phone">Phone (optional)</label>
                <input
                  id="global-phone"
                  name="phone"
                  type="tel"
                  value={requestData.phone}
                  onChange={handleRequestChange}
                />

                <label htmlFor="global-type">Type</label>
                <select id="global-type" name="type" value={requestData.type} onChange={handleRequestChange}>
                  <option>GIS Consulting</option>
                  <option>Cartography</option>
                </select>

                <label htmlFor="global-company">Company</label>
                <input
                  id="global-company"
                  name="company"
                  type="text"
                  value={requestData.company}
                  onChange={handleRequestChange}
                  required
                />

                <label htmlFor="global-moreInformation">More information</label>
                <textarea
                  id="global-moreInformation"
                  name="moreInformation"
                  rows="4"
                  value={requestData.moreInformation}
                  onChange={handleRequestChange}
                  required
                />

                <button type="submit" className="global-request-submit" disabled={requestSubmitting}>
                  {requestSubmitting ? 'Sending...' : 'Submit Request'}
                </button>
                {requestError && (
                  <p className="global-request-error">{requestError}</p>
                )}
                {requestSubmitted && (
                  <p className="global-request-message">Thank you. Your request has been sent.</p>
                )}
              </form>
            </div>
          </div>
        )}
      </div>
    </Router>
  );
}

export default App;
